import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGenericJSON } from '../helpers/interface';

export interface UserMeetingPreferences {
  allowedDurations: number[];
  availabilityIntervals: {
    day_of_week: string;
    start_time: string;
    end_time: string;
  }[];
  blockedAvailabilityIntervals: {
    start_date: string;
    end_date: string;
    all_day: boolean;
    start_time: string | null;
    end_time: string | null;
    reason: string | null;
  }[];
  meetingsPerDay: number | null;
  instructions: string | null;
  inPersonLocation?: string | null;
  onlinePlatform?: 'Google Meet' | 'Microsoft Teams' | 'Zoom' | null;
}

@Injectable({ providedIn: 'root' })
export class UserMeetingPreferencesService {
  private http = inject(HttpClient);
  private base = '/api/user-meeting-preferences';

  /**
   * Fetches a user's meeting scheduling preferences by their user id.
   * @param {number} userId - The user id of the counselor/host.
   * @returns {Observable<UserMeetingPreferences>}
   */
  getUserMeetingPreferences(userId: number): Observable<UserMeetingPreferences> {
    return this.http.get<UserMeetingPreferences>(`${this.base}/${userId}`);
  }

  updateUserMeetingPreferences(
    userId: number,
    preferences: IGenericJSON,
  ): Observable<IGenericJSON> {
    return this.http.put<IGenericJSON>(`${this.base}/${userId}`, preferences);
  }
}
